import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Container, Row, Col, Card, CardHeader, Button } from "@/Components/ui";
import { membershipService } from "../../api/services/membership.service";
import { MemberInvitationConfirmResponse } from "../../api/types/member";

const InviteConfirmPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [isLoading, setIsLoading] = React.useState(true);
  const [result, setResult] = React.useState<MemberInvitationConfirmResponse | null>(null);
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    if (!token) {
      setErrorMessage("유효하지 않은 초대 링크입니다.");
      setIsLoading(false);
      return;
    }

    membershipService.confirmInvitation({ token })
      .then((response) => {
        const data = response.data;

        if (data.requires_registration) {
          navigate(`/invite/register?token=${encodeURIComponent(token)}`, {
            state: {
              email: data.email,
              site_id: data.site_id,
              permission: data.permission,
              user: data.user,
            },
            replace: true,
          });
          return;
        }

        setResult(data);
      })
      .catch((error) => {
        console.log("invite confirm error", error);
        const apiData = error?.response?.data;
        setErrorMessage(apiData?.message || apiData?.detail || "초대 검증에 실패했습니다.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [token, navigate]);

  if (isLoading) {
    return (
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardHeader className="border-0">
              <h5 className="card-title mb-0">초대 처리 중...</h5>
            </CardHeader>
            <div className="card-body py-4">
              <p className="mb-0">초대 정보를 확인하고 있습니다.</p>
            </div>
          </Card>
        </Container>
      </div>
    );
  }

  if (errorMessage || !result) {
    return (
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg={8}>
              <Card>
                <CardHeader className="border-0">
                  <h5 className="card-title mb-0 text-danger">초대 승인 실패</h5>
                </CardHeader>
                <div className="card-body py-4">
                  <p className="mb-3">{errorMessage || "처리할 수 없는 초대입니다."}</p>
                  <Button color="secondary" onClick={() => navigate("/login")}>
                    로그인 페이지로 이동
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card>
              <CardHeader className="border-0">
                <h5 className="card-title mb-0">초대 승인 완료</h5>
              </CardHeader>
              <div className="card-body py-4">
                <p className="mb-2">{result.message}</p>
                {result.user ? (
                  <p className="mb-2">
                    계정: {result.user.username || "-"} ({result.user.phone_num}, {result.user.email})
                  </p>
                ) : null}
                <p className="mb-4">지점 ID: {result.site_id || "-"}</p>
                <Button color="secondary" onClick={() => navigate("/login")}>
                  로그인 페이지로 이동
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InviteConfirmPage;
